export class TestimonialTranslation {
  public language: string;
  public text: string;

  constructor(language: string, text: string) {
    this.language = language;
    this.text = text;
  }
}
